import { createEvent } from "library/local-events/index.mjs"

export const AllowPrinting = createEvent("AllowPrinting")
